import React from "react";

import './MapLoader.scss';

const MapLoader: React.FC = () => {
    return <div className="map-loader"></div>
}

export default MapLoader;
